// ---------------------------------------------------------------------------
// Phase 191 — role helpers shared by the shell, settings and the view-only engine.
//
//   admin        everything
//   team_member  edits within the modules / jobs the admin allows
//   read_only    "Read Only — view all": sees every section like an admin, changes / downloads / exports nothing
//   contractor   reduced shell, assigned jobs only
//   client / supplier / consultant / surveyor   portal accounts
// ---------------------------------------------------------------------------

export const READ_ONLY_ROLE = "read_only";

export const ROLE_LABELS = {
  admin: "Admin",
  team_member: "Team member",
  contractor: "Contractor",
  [READ_ONLY_ROLE]: "Read Only — view all",
};

export const roleLabel = (role) => ROLE_LABELS[role] || (role ? role.replace(/_/g, " ") : "");

/** The signed-in account can look at everything but must never change anything. */
export const isReadOnlyUser = (user) => !!user && user.role === READ_ONLY_ROLE;

/** Admin *visibility* — admins and read-only viewers see the same screens (settings, users, reports). Never use this
 *  to decide whether something may be edited; use `isAdmin` for that. */
export const isAdminLike = (user) => !!user && (user.role === "admin" || user.role === READ_ONLY_ROLE);

/** Accounts that live in the main BuiltOS shell (not a portal, not the contractor shell). */
export const isStaffUser = (user) => !!user && ["admin", "team_member", READ_ONLY_ROLE].includes(user.role);

export const READ_ONLY_MESSAGE = "View-only account — you can see everything but can't make changes, download or export.";
